import { all, call, put } from 'redux-saga/effects';

// Shared by homeSaga and helpSaga — fetch section list, then parallel-fetch contents.
export function* loadKBTree({ apiFns, actions, currentLocale }) {
  const response = yield call(apiFns.getSections, { currentLocale });
  yield put(actions.putSections({ currentLocale, response }));

  // NOTE: the [...spread] is load-bearing — `sectionCodes` is an Immutable
  // List, and `yield all(<ImmutableList>)` iterates internal struct keys
  // instead of effects, silently skipping every call/put. Keep the spread.
  const sectionCodes = response.get('data').map((x) => x.get('code'));
  const sectionResponses = yield all([
    ...sectionCodes.map((code) =>
      call(apiFns.getSectionContent, { currentLocale, code }),
    ),
  ]);

  yield all([
    ...sectionCodes.map((code, index) =>
      put(
        actions.putSectionContent({ code, response: sectionResponses[index] }),
      ),
    ),
  ]);

  yield put(actions.putContentsLoaded());
}
